// Judge.me reviews
document.addEventListener("DOMContentLoaded", () => {
  const widget = document.querySelector("#judgeme_product_reviews");

  if (!widget) {
    return;
  }

  const mutationObserver = new MutationObserver(() => {
    const stars = widget.querySelectorAll(".jdgm-star");

    stars.forEach((star) => {
      const hasSvg = star.querySelector("svg");

      if (hasSvg) {
        return;
      }

      if (star.classList.contains("jdgm--on")) {
        star.innerHTML = `
          <svg width="21" height="21" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.58332 3.32332L10.9443 7.39707L15.2981 7.47424L16.082 7.48814L15.4524 7.95361L11.9983 10.507L13.2707 14.6726L13.4994 15.4214L12.8622 14.9665L9.36632 12.4705L5.79807 14.9675L5.15554 15.4172L5.39166 14.6695L6.68497 10.5742L3.20785 7.95258L2.58203 7.48072L3.36625 7.47424L7.65996 7.43876L9.07896 3.32125L9.33468 2.5791L9.58332 3.32332Z" fill="rgb(var(--color-rating))"/>
          </svg>
        `;
      } else if (star.classList.contains("jdgm--off")) {
        star.innerHTML = `
          <svg width="21" height="21" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.58332 3.32332L10.9443 7.39707L15.2981 7.47424L16.082 7.48814L15.4524 7.95361L11.9983 10.507L13.2707 14.6726L13.4994 15.4214L12.8622 14.9665L9.36632 12.4705L5.79807 14.9675L5.15554 15.4172L5.39166 14.6695L6.68497 10.5742L3.20785 7.95258L2.58203 7.48072L3.36625 7.47424L7.65996 7.43876L9.07896 3.32125L9.33468 2.5791L9.58332 3.32332Z" fill="rgba(var(--color-text), 0.1)"/>
          </svg>
        `;
      }
    });
  });

  mutationObserver.observe(widget, {
    attributes: true,
    childList: true,
    subtree: true
  });
});